import { render, staticRenderFns } from "./ComparisonOfClassHistory.vue?vue&type=template&id=0f81b636&scoped=true&"
import script from "./ComparisonOfClassHistory.vue?vue&type=script&lang=js&"
export * from "./ComparisonOfClassHistory.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonOfClassHistory.vue?vue&type=style&index=0&id=0f81b636&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81b636",
  null
  
)

export default component.exports